import { gql } from '@apollo/client';

export default gql`
  mutation removePreferencesBusinessType($input: BusinessTypeInput!) {
    removeBuyerPreferencesBusinessType(input: $input)
  }
`;
